import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { PositionRenderer } from 'timeSheet/components/CellRenderers';

const usePositionColumn = ({ mappedPositions }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback(({ data }) => (data?.positionId ? mappedPositions[data?.positionId]?.slug : ''), [
    mappedPositions
  ]);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return PositionRenderer({
        rowData: params.data,
        columnData: { mappedPositions }
      });
    },
    [mappedPositions]
  );

  return useMemo(
    () => ({
      field: 'positionId',
      headerName: t('position'),
      width: 180,
      cellClass: 'align-start direction-column',
      valueGetter,
      filterParams: {
        valueFormatter: ({ value }) => (value ? mappedPositions[value]?.slug : '')
      },
      cellRenderer
    }),
    [t, valueGetter, cellRenderer, mappedPositions]
  );
};

export default usePositionColumn;
